import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Customer, Address } from "../../../../core/api/models";
import { State } from "../../../../core/store/interfaces";
import classnames from "classnames";
import EditName from "./EditName";
import EditPhone from "./EditPhone";
import EditEmail from "./EditEmail";
import AddAddress from "./AddAddress";
import EditFiled from "./EditFiled";
import { format, differenceInYears } from "date-fns";
import api from "../../../../api";
import {
  capitalizeFirstLetter,
  AppPermissions,
  useHasPermission,
  isVerified,
  CompanyCustomerEditModalType,
  customerContactType,
} from "../../../../core";
import EditCivilId from "../../../leads/components/EditCivilId";
import EditSelectField from "./EditSelectField";
import EditInfluencer from "./EditInfluencer";
import nationalities from "../../../../utils/nationality.json";
import EditAssistantDetails from "./EditAssistantDetails";
import { AgeLimit } from "../../../../core/models/customer";
import AddressDetalsView from "../AddressDetalsView";
import EditDOB from "../EditDOB";
import { RouteKeys } from "../../../routes/route-keys";
import { useHistory } from "react-router";

const CustomeList: React.FunctionComponent<{
  error?: string;
  setStage?: (stage: string) => void;
  updateUser?: (details: Customer) => void;
  companyId?: string;
  leadId?: string;
}> = (props) => {
  const history = useHistory();
  const leadState = useSelector((state: State) => state.lead);

  const dataToPass = leadState?.leadDetails?.corporateUsers;

  const [resetState, setResetState] = useState(dataToPass);
  const loadLead = async (leadId: string) => {
    const response = await api.lead.getLead(leadId);
    setResetState(response?.data?.corporateUsers);
  };

  React.useEffect(() => {
    if (leadState?.leadDetails?.corporateUsers) {
      setResetState(leadState?.leadDetails?.corporateUsers);
    }
  }, [leadState?.leadDetails?.corporateUsers]);

  const canUpdateCustomerContacts = useHasPermission(AppPermissions.UpdateCustomerContacts);

  const canViewCustomerAddress = useHasPermission(AppPermissions.ViewCustomerAddress);

  const [customerModal, setCustomerModal] = useState<{
    isOpen?: boolean;
    customerId?: string;
  }>({});

  const [addressToDelete, setAddressToDelete] = useState<Address>();

  const [editModal, setEditModal] = React.useState<CompanyCustomerEditModalType>({});
  const [isShowMore, setShowMore] = useState<boolean>(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const [isShowSetExpectedCloseDate, setShowSetExpectedCloseDate] = useState<boolean>(false);

  const loadInfluence = async () => {
    const response = await api.influencer.loadAllInfluencer();
    return response;
  };

  const loadDesignation = async () => {
    const response = await api.designation.loadAllDesignation();
    return response;
  };

  const loadDivision = async () => {
    const response = await api.divisionsUnderCompany.loadAllDivisions();
    return response;
  };

  const [selectedCustomer, setSelectedCustomer] = useState<Customer>();

  const [selectedAddress, setSelectedAddress] = useState<Address>();

  const selectAddress = (address?: Address, customerDetails?: Customer) => {
    setSelectedAddress(address);
    setEditModal({ isShowAddressForm: true, id: customerDetails?._id });
    setSelectedCustomer(selectedCustomer);
  };

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target) &&
      !event.target.className?.includes("react-datepicker__day")
    ) {
      setShowSetExpectedCloseDate(false);
    }
  };

  const onCloseDeleteConfirm = () => {
    setAddressToDelete(undefined);
    setSelectedCustomer(undefined);
  };

  const onCancelAndStateRefresh = () => {
    if (props.leadId) {
      loadLead(props.leadId);
    }
    setEditModal({});
  };

  const onRemoveAddress = async (customerDetails?: Customer) => {
    let addresses = customerDetails && customerDetails?.addresses ? customerDetails?.addresses : [];
    if (addressToDelete) {
      addresses = addresses.filter((x) => x._id !== addressToDelete?._id);
      const updateData: Customer = {
        addresses,
      };
      try {
        const response = await api.customer.updateCustomer(updateData, customerDetails?._id || "");
        setAddressToDelete(undefined);
        props.updateUser?.(response);
        onCancelAndStateRefresh();
      } catch (error) {
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message);
        } else {
          toastr.error("Error", error?.response?.data?.message);
        }
      }
    }
  };

  const renderDelete = () => {
    return addressToDelete ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>Are you sure want to delete this address</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={onCloseDeleteConfirm}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => onRemoveAddress(selectedCustomer)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  const on360Click = (customerDetails: Customer) => {
    history.push(`${RouteKeys.Lead360View}/${customerDetails?._id}`);
  };

  return !!resetState?.length ? (
    <>
      <div className="d-flex border-bottom align-items-center py-3 px-4 bg-gray-100">
        <h6 className="mb-0">Contact Details</h6>
      </div>
      {resetState?.map((customerDetails) => {
        return (
          <>
            <div className="d-flex flex-wrap px-4 py-3 border-bottom">
              <div className="pl-1 flex-fill position-relative">
                <div className="row no-gutters align-items-center">
                  <h6 role="button" className="font-weight-semibold mb-1 font-normal" onClick={()=>on360Click(customerDetails)}>
                    {customerDetails?.prefix ? customerDetails?.prefix + "." : ""}{" "}
                    {customerDetails?.firstName} {customerDetails?.lastName}
                    {customerDetails?.shortName && (
                      <span className="font-weight-normal">({customerDetails?.shortName})</span>
                    )}
                  </h6>
                  <div className="ml-auto">
                    <i
                      onClick={() => {
                        if (customerModal.isOpen) {
                          setCustomerModal({});
                        } else {
                          setCustomerModal({
                            isOpen: true,
                            customerId: customerDetails?._id,
                          });
                        }
                      }}
                      className={classnames({
                        "font-xs text-gray-700 cursor-pointer": true,
                        "icon-chevron-down": !(
                          customerModal.isOpen && customerModal.customerId === customerDetails?._id
                        ),
                        "icon-chevron-up": !!(
                          customerModal.isOpen && customerModal.customerId === customerDetails?._id
                        ),
                      })}
                    ></i>
                  </div>
                </div>
                <div className="row no-gutters align-items-center mb-0 font-sm font-weight-semibold">
                  <div className="col-auto text-gray-600">{customerDetails?.influencer?.name}</div>
                  {customerDetails?.designation && customerDetails?.influencer && (
                    <div className="bg-gray-400 mx-2 top-0"></div>
                  )}
                  {customerDetails?.designation && (
                    <div className="col-auto text-gray-600">
                      {customerDetails?.designation?.name}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {customerModal.isOpen && customerModal.customerId === customerDetails?._id && (
              <div className="border-bottom pb-2">
                {!editModal.isEditName || editModal.id !== customerDetails?._id ? (
                  <div className="mt-2 d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                    <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                      Title
                    </div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">{customerDetails?.prefix}</div>
                      {canUpdateCustomerContacts && (
                        <i
                          onClick={() =>
                            setEditModal({
                              isEditName: true,
                              id: customerDetails?._id,
                            })
                          }
                          className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                        ></i>
                      )}
                    </div>
                    <div className="w-100"></div>
                    <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                      First Name
                    </div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">
                        {customerDetails?.firstName}
                      </div>
                    </div>
                    <div className="w-100 mb-2"></div>
                    {/* <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                      Middle Name
                    </div> */}
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">
                        {customerDetails?.middleName}{" "}
                      </div>
                    </div>
                    <div className="w-100 mb-2"></div>
                    <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                      Last Name
                    </div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">
                        {customerDetails?.lastName}{" "}
                      </div>
                    </div>
                    <div className="w-100 mb-2"></div>
                  </div>
                ) : (
                  <EditName
                    onClose={() => onCancelAndStateRefresh()}
                    updateUser={(details: Customer) => props.updateUser?.(details)}
                    customerDetails={customerDetails}
                  ></EditName>
                )}

                {!editModal.isEditPhone || editModal.id !== customerDetails?._id ? (
                  <>
                    <div className="d-flex flex-wrap px-4 py-1 contact-form-row flex-wrap">
                      <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right  pt-2">
                        Phone
                      </div>
                      <div className="col pl-2 pr-0 contact-content d-flex align-items-center flex-wrap">
                        {customerDetails?.phones?.length === 0 && canUpdateCustomerContacts && (
                          <i
                            onClick={() =>
                              setEditModal({
                                isEditPhone: true,
                                id: customerDetails?._id,
                              })
                            }
                            className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                          ></i>
                        )}

                        {customerDetails?.phones?.map((item, index) => {
                          return (
                            <>
                              {item.isPrimary ? (
                                <i className="icon-tick font-xxxs text-shamrock mr-1"></i>
                              ) : (
                                // <i className="icon-tick font-xxxs text-shamrock mr-1 hide-visibility"></i>
                                <i
                                  className="font-weight-bold font-xxxs icon-close mr-1 text-red"
                                  title="not verified"
                                ></i>
                              )}

                              <div className="font-sm font-weight-semibold">
                                +{item.phone}{" "}
                                {item.phoneType && (
                                  <span className="text-gray-500">({item.phoneType})</span>
                                )}
                              </div>
                              {item.isPrimary && (
                                <i className="icon-primary-contact font-xs ml-1"></i>
                              )}
                              {index === 0 && canUpdateCustomerContacts && (
                                <i
                                  onClick={() =>
                                    setEditModal({
                                      isEditPhone: true,
                                      id: customerDetails?._id,
                                    })
                                  }
                                  className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                                ></i>
                              )}

                              <div className="w-100"></div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : (
                  <EditPhone
                    onClose={() => onCancelAndStateRefresh()}
                    updateUser={(details: Customer) => props.updateUser?.(details)}
                    customerDetails={customerDetails}
                  ></EditPhone>
                )}

                {!editModal.isEditEmail || editModal.id !== customerDetails?._id ? (
                  <>
                    <div className="d-flex flex-wrap px-4 py-1 contact-form-row flex-wrap">
                      <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right  pt-2">
                        E-mail
                      </div>
                      <div className="col pl-2 pr-0 contact-content d-flex align-items-center flex-wrap">
                        {customerDetails?.emails?.length === 0 && canUpdateCustomerContacts && (
                          <i
                            onClick={() =>
                              setEditModal({
                                isEditEmail: true,
                                id: customerDetails?._id,
                              })
                            }
                            className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                          ></i>
                        )}

                        {customerDetails?.emails?.map((item, index) => {
                          return (
                            <>
                              {item.isPrimary ? (
                                <i className="icon-tick font-xxxs text-shamrock mr-1"></i>
                              ) : (
                                <i
                                  className="font-weight-bold font-xxxs icon-close mr-1 text-red"
                                  title="not verified"
                                ></i>
                              )}
                              <div className="font-sm font-weight-semibold">
                                {item.email}{" "}
                                {item.emailType && (
                                  <span className="text-gray-500">({item.emailType})</span>
                                )}
                              </div>
                              {item.isPrimary && (
                                <i className="icon-primary-contact font-xs ml-1"></i>
                              )}
                              {index === 0 && canUpdateCustomerContacts && (
                                <i
                                  onClick={() =>
                                    setEditModal({
                                      isEditEmail: true,
                                      id: customerDetails?._id,
                                    })
                                  }
                                  className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                                ></i>
                              )}
                              <div className="w-100"></div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </>
                ) : (
                  <EditEmail
                    onClose={() => onCancelAndStateRefresh()}
                    updateUser={(details: Customer) => props.updateUser?.(details)}
                    customerDetails={customerDetails}
                  ></EditEmail>
                )}
                {/* {!editModal.isEditAgeLimit || editModal.id !== customerDetails?._id ? (
                  <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                    <div className="ol pl-2 pr-2 contact-label text-right font-xs text-gray-500 pt-2">
                      Age Limit
                    </div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">
                        {customerDetails?.ageRange}
                      </div>
                      <i
                        onClick={() => setEditModal({ isEditAgeLimit: true })}
                        className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                      ></i>
                    </div>
                  </div>
                ) : (
                  <EditSelectField
                    onClose={() => onCancelAndStateRefresh()}
                    updateUser={(details: Customer) => props?.updateUser?.(details)}
                    customerDetails={customerDetails}
                    property={"ageRange"}
                    value={customerDetails?.ageRange}
                    title={"Age Limit"}
                    options={AgeLimit.map((age) => ({ name: age.name, _id: age.name }))}
                  ></EditSelectField>
                )} */}

                {!editModal.isEditInfluencer || editModal.id !== customerDetails?._id ? (
                  <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                    <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                      Influencer
                    </div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">
                        {customerDetails?.influencer?.name}
                      </div>
                      <i
                        onClick={() =>
                          setEditModal({
                            isEditInfluencer: true,
                            id: customerDetails?._id,
                          })
                        }
                        className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                      ></i>
                    </div>
                  </div>
                ) : (
                  <EditInfluencer
                    onClose={() => onCancelAndStateRefresh()}
                    updateUser={(details: Customer) => props.updateUser?.(details)}
                    customerDetails={customerDetails}
                    property={"influencerId"}
                    value={customerDetails?.influencer?._id}
                    title={"Influencer"}
                    loadData={loadInfluence}
                  ></EditInfluencer>
                )}
                {/* {!editModal.isEditDob ? (
                  <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                    <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                      DOB
                    </div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <div className="font-sm font-weight-semibold">
                        {customerDetails?.dob && (
                          <>
                            {format(new Date(customerDetails?.dob), "dd/MM/yyyy")}
                            <span className="text-gray-500">
                              ({differenceInYears(new Date(), new Date(customerDetails?.dob))} years
                              old)
                            </span>
                          </>
                        )}
                      </div>
                      {canUpdateCustomerContacts && (
                        <i
                          onClick={() => setEditModal({ isEditDob: true })}
                          className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                        ></i>
                      )}
                    </div>
                  </div>
                ) : (
                  <EditDOB
                    onClose={() => onCancelAndStateRefresh()}
                    updateUser={(details: Customer) => props?.updateUser?.(details)}
                    customerDetails={customerDetails}
                  ></EditDOB>
                )} */}

                {!isShowMore ? (
                  <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap bg-white">
                    <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right "></div>
                    <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                      <button
                        onClick={() => setShowMore(true)}
                        className="btn btn-link font-xs p-0 font-weight-semibold"
                      >
                        Show more
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    {!editModal.isEditContactCategory || editModal.id !== customerDetails?._id ? (
                      <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                        <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                          Contact Category
                        </div>
                        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                          <div className="font-sm font-weight-semibold">
                            {customerDetails?.customerContactType}
                          </div>
                          <i
                            onClick={() =>
                              setEditModal({
                                isEditContactCategory: true,
                                id: customerDetails?._id,
                              })
                            }
                            className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                          ></i>
                        </div>
                      </div>
                    ) : (
                      <EditSelectField
                        onClose={() => onCancelAndStateRefresh()}
                        updateUser={(details: Customer) => props.updateUser?.(details)}
                        customerDetails={customerDetails}
                        property={"customerContactType"}
                        value={customerDetails?.customerContactType}
                        title={"Contact Category"}
                        options={customerContactType?.map((key) => {
                          return {
                            name: key.name,
                            _id: key.value,
                          };
                        })}
                      ></EditSelectField>
                    )}
                    {!editModal.isEditDesignation ? (
                      <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                        <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                          Designation
                        </div>
                        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                          <div className="font-sm font-weight-semibold">
                            {customerDetails?.designation?.name}
                          </div>
                          <i
                            onClick={() => setEditModal({ isEditDesignation: true })}
                            className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                          ></i>
                        </div>
                      </div>
                    ) : (
                      <EditSelectField
                        onClose={() => onCancelAndStateRefresh()}
                        updateUser={(details: Customer) => props.updateUser?.(details)}
                        customerDetails={customerDetails}
                        property={"designationId"}
                        searchable
                        value={customerDetails?.designation?.name}
                        title={"Designation"}
                        loadData={loadDesignation}
                      ></EditSelectField>
                    )}

                    <EditAssistantDetails
                      onClose={() => onCancelAndStateRefresh()}
                      customerDetails={customerDetails}
                      editModal={editModal}
                      setEditModal={setEditModal}
                      updateUser={(details: Customer) => props.updateUser?.(details)}
                    />

                    {/* {!editModal.isRemarks ? (
                      <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">
                          Remarks
                        </div>
                        <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                          <div className="font-sm font-weight-semibold ">
                            {customerDetails?.remarks}
                          </div>
                          <i
                            onClick={() => setEditModal({ isRemarks: true })}
                            className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                          ></i>
                        </div>
                      </div>
                    ) : (
                      <EditFiled
                        onClose={() => onCancelAndStateRefresh()}
                        updateUser={(details: Customer) => props?.updateUser?.(details)}
                        customerDetails={customerDetails}
                        property={"remarks"}
                        value={customerDetails?.remarks}
                        title={"Remarks"}
                        textArea
                      ></EditFiled>
                    )} */}

                    <div className="contact-label font-sm font-weight-semibold px-4 mt-1 ">
                      Address
                    </div>
                    {canViewCustomerAddress && (
                      <div className="d-flex flex-column py-1 ">
                        {customerDetails?.addresses?.map((item) => {
                          return (
                            <div className="contact-form-row ">
                              <div className="contact-content d-flex flex-column ">
                                <div className="d-flex mb-2 flex-column">
                                  <div className="d-flex justify-content-end align-items-center ">
                                    {item.isPrimary ? (
                                      <i className="icon-tick font-xxxs text-shamrock mr-1 pt-1"></i>
                                    ) : (
                                      <i className="icon-tick font-xxxs text-shamrock mr-1 pt-1 hide-visibility"></i>
                                    )}
                                    {canUpdateCustomerContacts &&
                                      (!leadState?.leadDetails ||
                                        leadState?.leadDetails?.isEditable) && (
                                        <>
                                          <i
                                            onClick={() => {
                                              setSelectedCustomer(customerDetails);
                                              setAddressToDelete(item);
                                            }}
                                            className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"
                                          ></i>
                                          <i
                                            onClick={() => selectAddress(item)}
                                            className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-3 contact-edit bg-white"
                                          ></i>
                                        </>
                                      )}
                                  </div>
                                  <AddressDetalsView addressDetails={item} />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div className="w-100 mb-3"></div>
                        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500"></div>
                        {!editModal.isShowAddressForm &&
                          canUpdateCustomerContacts &&
                          (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                            <button
                              onClick={() => selectAddress()}
                              className="btn btn-link font-sm p-0 font-weight-semibold"
                            >
                              + add{" "}
                              {customerDetails &&
                              customerDetails.addresses &&
                              customerDetails.addresses.length > 0
                                ? "one more"
                                : " address"}{" "}
                            </button>
                          )}
                      </div>
                    )}

                    {editModal.isShowAddressForm && (
                      <AddAddress
                        onClose={() => onCancelAndStateRefresh()}
                        updateUser={(details: Customer) => props.updateUser?.(details)}
                        selectedAddress={selectedAddress}
                        customerDetails={customerDetails}
                      ></AddAddress>
                    )}
                    <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap bg-white">
                      <div className="col px-2 contact-label text-right font-xs text-gray-500"></div>
                      <div className="col px-2 contact-content d-flex align-items-center">
                        <button
                          onClick={() => setShowMore(false)}
                          className="btn btn-link font-xs p-0 font-weight-semibold"
                        >
                          Show less
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            {renderDelete()}
          </>
        );
      })}
    </>
  ) : (
    <></>
  );
};

export default CustomeList;
